import { render } from "./Bets.vue?vue&type=template&id=1521bd16"
import script from "./Bets.vue?vue&type=script&lang=js"
export * from "./Bets.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__